import React from "react";
import styled from "styled-components";

const ResponsiveFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  ${props => props.theme.media.tabletUp`
    flex-direction: row;
  `};
`;

export default ({ children, className }) => (
  <ResponsiveFlexContainer className={className}>
    {children}
  </ResponsiveFlexContainer>
);
